import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import FooterLabel from './FooterLabel'
import { ProgressChart } from '../..'
import { colors } from '../../../constants'
import Centered from '../../Centered'
import Loader from '../../Loader'

const Wrapper = styled.div`
    background: ${colors.bluedarkest};
    color: ${colors.white};
    height: 100%;
    overflow: hidden;
    width: 100%;
`

const Body = styled.div`
    background: ${colors.bluedarkest};
    color: ${colors.white};
    position: relative;
    width: 100%;

    ${({ fullHeight }) =>
        fullHeight
            ? `height: 100%;`
            : `
        height: calc(100% - 45px);

        @media (max-height: 1220px) {
          height: calc(100% - 30px);
        }
      `}
`

const Footer = styled.div`
    background: ${colors.blueultradarkest};
    color: ${colors.white};
    height: 45px;
    position: relative;
    width: 100%;

    @media (max-height: 1220px) {
        height: 30px;
    }
`

const FloatingLabel = styled.div`
    align-items: center;
    color: ${colors.grey};
    display: flex;
    font-size: 14px;
    height: 100%;
    left: 0;
    padding: 15px 10px;
    position: absolute;
    top: 0;
    width: 100%;
`

function BlueBox({ children, loading, noFooter, noResults, ...props }) {
    if (noFooter) {
        return (
            <Wrapper {...props}>
                <Body fullHeight>
                    {loading && (
                        <Centered horizontal vertical>
                            <Loader />
                        </Centered>
                    )}
                    {!loading && children}
                </Body>
            </Wrapper>
        )
    }

    return (
        <Wrapper {...props}>
            <Body>{children}</Body>
            <Footer>
                {typeof loading === 'number' && <ProgressChart value={loading} size="md" />}
                <FloatingLabel>
                    <FooterLabel loading={loading} noResults={noResults} />
                </FloatingLabel>
            </Footer>
        </Wrapper>
    )
}

BlueBox.propTypes = {
    children: PropTypes.node,
    loading: PropTypes.bool,
    noFooter: PropTypes.bool,
    noResults: PropTypes.bool,
}

BlueBox.defaultProps = {
    children: null,
    loading: false,
    noFooter: false,
    noResults: false,
}

export default BlueBox
